import { Tick } from '@sainsburys-tech/icons'
import React from 'react'

import Banner from './Banner'

interface IConfirmationBanner {
  message: string
}

const ConfirmationBanner = ({ message }: IConfirmationBanner) => (
  <Banner
    data-testid='confirmation-banner'
    message={message}
    icon={<Tick />}
    className='c-common-banner--success'
  />
)

export default ConfirmationBanner
